import React from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const money = (value) => `NZ$${Number(value || 0).toFixed(2)}`;

export const FinanceCharts = ({ monthly = [], categories = [] }) => (
  <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.4fr)_minmax(320px,0.8fr)] gap-4">
    <section className="bg-white border p-4 sm:p-5 min-w-0" style={{ borderColor: "#E8DFCB" }} data-testid="finance-monthly-chart">
      <div className="text-[10px] tracking-[0.3em] uppercase font-semibold text-[#6E1E3A] mb-4">Monthly income vs outgoing</div>
      {monthly.length === 0 ? <Empty text="Import a statement to start the monthly graph." /> : (
        <ResponsiveContainer width="100%" height={280}>
          <ComposedChart data={monthly} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
            <CartesianGrid stroke="#6E1E3A18" strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#5A4565" }} />
            <YAxis tick={{ fontSize: 10, fill: "#5A4565" }} tickFormatter={(value) => `$${value}`} width={58} />
            <Tooltip formatter={(value) => money(value)} contentStyle={{ background: "#FBF6E9", border: "1px solid #E8DFCB", borderRadius: 4 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="income" name="Income" fill="#2F6B4F" radius={[2, 2, 0, 0]} />
            <Bar dataKey="outgoing" name="Outgoing" fill="#A14C4C" radius={[2, 2, 0, 0]} />
            <Line dataKey="net" name="Net movement" stroke="#C49247" strokeWidth={3} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </section>
    <section className="bg-white border p-4 sm:p-5" style={{ borderColor: "#E8DFCB" }} data-testid="finance-category-breakdown">
      <div className="text-[10px] tracking-[0.3em] uppercase font-semibold text-[#6E1E3A] mb-4">Category breakdown</div>
      {categories.length === 0 ? <Empty text="No categorised transactions yet." /> : (
        <div className="space-y-3 max-h-[280px] overflow-y-auto pr-1">
          {categories.map((category) => {
            const max = Math.max(...categories.map((item) => item.total), 1);
            return (
              <div key={category.category} data-testid={`finance-category-${category.category}`}>
                <div className="flex items-center justify-between gap-3 text-xs">
                  <span className="font-semibold text-[#3C2A1E]">{category.label}</span>
                  <span className="font-mono text-[#5A4565]">{money(category.total)}</span>
                </div>
                <div className="h-2 bg-[#F4ECD8] mt-1 overflow-hidden"><div className="h-full bg-[#7C5E8A]" style={{ width: `${Math.max(3, (category.total / max) * 100)}%` }} /></div>
                <div className="text-[10px] text-[#7A6A55] mt-0.5">{category.count} transaction{category.count === 1 ? "" : "s"} · income {money(category.income)} · outgoing {money(category.outgoing)}</div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  </div>
);

const Empty = ({ text }) => <div className="h-[220px] grid place-items-center text-sm italic text-[#8A7A66] text-center px-5">{text}</div>;